// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"8e8f696f","453":"72ddda0d"}[chunkId] + ".chunk.js";
};